import { Component, Input, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { TimeSetupService } from "../shared/data.service";
import * as moment from "moment";

@Component({
	selector: "caass-start-period-grid",
	templateUrl: "./start-period-grid.component.html",
	styleUrls: ["./start-period-grid.component.css"],
})
export class StartPeriodGridComponent implements OnInit {
	constructor(private timeSetupService: TimeSetupService, private confirmationService: ConfirmationService) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		if (this.SchoolID != undefined) {
			this.loadPeriodList();
		}
	}

	ngOnChanges() {
		if (this.SchoolID != undefined) {
			this.loadPeriodList();
		}
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Input() SchoolID: any;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedPeriod: any;
	lstPeriod: any = [];

	//Filter lists

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "PeriodNo", header: "Period No" },
		{ field: "PeriodDesc", header: "Description" },
		{ field: "StartTimeDesc", header: "Start Time" },
		{ field: "EndTimeDesc", header: "End Time" },

		// { field: 'TardyTime', header: 'Tardy Time' },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadPeriodList() {
		this.loading = true;

		var result = this.timeSetupService.TimeSettingsPeriodSelectList(this.SchoolID);
		result.subscribe(
			(response) => {
				this.lstPeriod = response;

				for (var i = 0; i < this.lstPeriod.length; i++) {
					var next = this.lstPeriod[i];

					next.StartTimeDesc = moment(new Date(next.StartTime)).format("hh:mm a");
					next.EndTimeDesc = moment(new Date(next.EndTime)).format("hh:mm a");

					//Create Date from Tardy Time string
					if (next.TardyTime != "0001-01-01T00:00:00") {
						next.TardyTimeDate = new Date(String(next.TardyTime));
					} else {
						//var Today = new Date();
						//Today.setHours(0, 0, 0, 0);
						//next.TardyTimeDate = Today;
						next.TardyTimeDate = new Date(next.StartTime);
					}
				}

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////
	onUpdate(val) {
		var fTime = "1900-01-01 " + moment(new Date(val.TardyTimeDate)).format("HH:mm:00");

		var result = this.timeSetupService.TimeSettingsUpdatePeriodTardyTime(val.PeriodID, fTime);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "timeperiod",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Period Tardy Time was updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.loadPeriodList();
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "timeperiod",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the Period's Tardy Time",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onReset(val) {
		//There should only be 1 school for a given school ID
		var next = val;

		var TodayStr: String = moment(new Date()).format("MM/DD/YYYY");

		if (next.TardyTime != "") {
			next.TardyTimeDate = new Date(String(next.TardyTime));
		} else {
			var Today = new Date();
			Today.setHours(0, 0, 0, 0);
			next.TardyTimeDate = Today;
		}
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////

	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedPeriod = val.data;
	}
	onRowUnselect(val) {
		this.SelectedPeriod = null;
	}

	////////////////////////////////////////////
}
